<template>
    <Paper id="identifying"
            v-loading="printloading"
            :element-loading-text="$translate('lang.E3202103090028', { defaultText: '排版打印中' })"
            element-loading-spinner="el-icon-loading">
            <div class="identifyingprint">
                    <div class="identifyingprint-top">
                        <el-button type="primary" @click="printButton('ruleForm')">{{$translate('lang.E3202103090001', { defaultText: '打印生成' })}}</el-button>
                        <el-button @click="restPrint" class="sn-search-reset-button">{{$translate('lang.E3202101260009', { defaultText: '重置' })}}</el-button>
                    </div>
                    <el-form ref="ruleForm" label-position="left" :inline="true"  :model="formInline" :rules="rules" class="demo-form-inline" label-width='90px'>
                        <el-form-item  class="positionClass" :label="$translate('lang.E3202103090029', { defaultText: '产品选择 :' })"
                        :title="$translate('lang.E3202103090029', { defaultText: '产品选择 :' })" prop="productName">
                            <el-input v-model="formInline.productName" :placeholder="$translate('lang.E3202103090002', { defaultText: '产品选择' })" @focus="detaliSearch"></el-input>
                            <span class="propertyClass">
                                <span class="propertyClass-img" @click="detaliSearch">
                                    <img src="../../../assets/images/add-option.svg" alt="">
                                </span>
                                <span @click="mouseOver" v-if="isProperty" class="propertyClass-text">
                                    {{$translate('lang.E3202103090011', { defaultText: '属性' })}}
                                </span>
                            </span>
                        </el-form-item>
                        <el-form-item :label="$translate('lang.E3202103090030', { defaultText: '生成规则 :' })"
                        :title="$translate('lang.E3202103090030', { defaultText: '生成规则 :' })" prop="identityRule">
                            <el-input v-model="formInline.identityRule" @focus="identifyGeneratedSearch" :placeholder="$translate('lang.E3202103090003', { defaultText: '生成规则' })"></el-input>
                            <span class="ruleClass">
                                <span class="ruleClass-img">
                                    <img src="../../../assets/images/batch-folding.svg" alt="">
                                </span>
                                <el-tooltip class="item" effect="light" :content="$translate('lang.E3202103090010', { defaultText: '规则说明: 企业前缀+版本+类别+时间+流水组成' })" placement="top">
                                    <span class="ruleClass-text">
                                        ?
                                    </span>
                                </el-tooltip>
                            </span>

                        </el-form-item>
                        <el-form-item :label="$translate('lang.E3202103090031', { defaultText: '打印模板 :' })"
                        :title="$translate('lang.E3202103090031', { defaultText: '打印模板 :' })" prop="template">
                            <el-select v-model="formInline.template" :placeholder="$translate('lang.E3202103090004', { defaultText: '打印模板' })">
                                <el-option
                                    v-for="item in templateOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="numCalss" :label="$translate('lang.E3202103090032', { defaultText: '打印份数 :' })"
                        :title="$translate('lang.E3202103090032', { defaultText: '打印份数 :' })" prop="printCopies">
                            <el-input-number v-model="formInline.printCopies" :min="1" :max="1000" controls-position="right"></el-input-number>
                        </el-form-item>
                        <el-form-item class="generateNumClass" :label="$translate('lang.E3202103090033', { defaultText: '生成数量 :' })"
                        :title="$translate('lang.E3202103090033', { defaultText: '生成数量 :' })" prop="createNum">
                            <el-input-number @change="getStartEndNum" v-model="formInline.createNum" :min="0" controls-position="right"></el-input-number>
                        </el-form-item>
                        <el-form-item class="identificationDate" :label="$translate('lang.E3202103090034', { defaultText: '生成日期 :' })"
                        :title="$translate('lang.E3202103090034', { defaultText: '生成日期 :' })" prop="createDate">
                            <el-date-picker @change="changeDate" value-format='yyyy-MM-dd' v-model="formInline.createDate" type="date"
                            :placeholder="$translate('lang.E3202101280018', { defaultText: '选择日期' })"></el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$translate('lang.E3202103090035', { defaultText: '号段起 :' })"
                        :title="$translate('lang.E3202103090035', { defaultText: '号段起 :' })" prop="startNum" class="themRoughlyClass">
                            <el-input :disabled="true" v-model="formInline.startNum"></el-input>
                        </el-form-item>
                        <el-form-item :label="$translate('lang.E3202103090036', { defaultText: '号段止 :' })"
                        :title="$translate('lang.E3202103090036', { defaultText: '号段止 :' })" prop="endNum" class="themRoughlyClassTwo">
                            <el-input :disabled="true" v-model="formInline.endNum"></el-input>
                        </el-form-item>
                    </el-form>
            </div>
        <!-- 产品信息 -->
        <el-dialog
            id="productInformation"
            :title="$translate('lang.E3202103090012', { defaultText: '选择产品' })"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            :show-close="showClose"
            width="60%">
                <printComponents
                    ref="Product"
                    :config="Informationconfig"
                    :pageTotal="InformationPageTotal"
                    :tableData="InformationTableData"
                    @onSearchChange="onSearchChange"
                    @onSelectionChange="productInformationSelec"
                    @pageChange="productPageChange"
                    @sizeChange="productSizeChange">
                </printComponents>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$translate('lang.E3202101270002', { defaultText: '取 消' })}}</el-button>
                <el-button type="primary" @click="productInformation">{{$translate('lang.E3202101270001', { defaultText: '确 定' })}}</el-button>
            </span>
        </el-dialog>
        <!-- 标识生成规则 -->
        <el-dialog
            id="identifyGenerated"
            :title="$translate('lang.E3202103090013', { defaultText: '标识生成规则选择' })"
            :visible.sync="identifyGeneratedVisible"
            :show-close="showClose"
            width="60%">
                <printComponents
                    @onSelectionChange="identifyGeneratedSelec"
                    :config="identifyconfig"
                    :tableData="identifyTableData">
                </printComponents>
            <span slot="footer" class="dialog-footer">
                <el-button @click="identifyGeneratedVisible = false">{{$translate('lang.E3202101270002', { defaultText: '取 消' })}}</el-button>
                <el-button type="primary" @click="identifyGenerated">{{$translate('lang.E3202101270001', { defaultText: '确 定' })}}</el-button>
            </span>
        </el-dialog>
        <!-- 属性查看 -->
        <el-dialog
            id="attributeClass"
            :title="$translate('lang.E3202103090014', { defaultText: '基础属性' })"
            :visible.sync="showProperty"
            width="60%">
                <div class="attribute-top">
                    <ul>
                        <li class="lispecific" v-for="(item, index) in attributeArray" :key="index">
                            <span>{{item.attributeName + ':'}}</span>
                            <span>
                                <el-input :disabled="true"  v-model="item.attributeValue" :placeholder="item.attributeName"></el-input>
                            </span>
                            <span v-if="item.name === '图片'">
                                <div class="demo-image__preview">
                                    <el-image
                                        style="width: 100px; height: 100px"
                                        :src="url"
                                        :preview-src-list="srcList">
                                    </el-image>
                                </div>
                            </span>
                        </li>
                    </ul>
                    <span class="attribute-hint" v-if="attributeArray.length === 0">{{$translate('lang.E3202102220011', { defaultText: '暂无数据' })}}</span>
                </div>
        </el-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import printComponents from '../../../components/IdentityComponent/Main.vue';
import Informationconfig from './Information.js';
import identifyconfig from './identifyconfig.js';
import { getProductList, getParagraph, Throttle, setRegistered, setSNumber } from '../../../api/identificationPrint';
import configHttp from '@/config/user.env';
import { mapGetters } from 'vuex';
export default {
    name: 'identificationPrint',
    components: { Paper, printComponents },
    data() {
        const validateNull = (rule, value, callback) => {
            if (value === 0) {
                return callback(new Error(this.$translate('lang.E3202103090037', { defaultText: '生成数量不能小于1' })));
            }
            callback();
        };
        return {
            isProperty: false,
            configHttp: configHttp,
            formInline: {
                productName: '',
                identityRule: 'R01',
                template: this.$translate('lang.E3202103090016', { defaultText: '家电工业互联网标识打印模版' }),
                printCopies: '',
                createNum: '',
                createDate: '',
                startNum: '',
                endNum: ''
            },
            Informationconfig: Informationconfig,
            identifyconfig: identifyconfig,
            pageTotal: 2,
            InformationPageTotal: 0,
            printloading: false,
            InformationTableData: [],
            identifyTableData: [
                {
                    identityRule: 'R01',
                    rulesName: '家电15位',
                    relesValue: 'E80.22/9897006K'
                }
            ],
            dialogVisible: false,
            showClose: false,
            identifyGeneratedVisible: false,
            printTemplateVisible: false,
            rules: {
                productName: [
                    { required: true, message: this.$translate('lang.E3202103090017', { defaultText: '请选择产品' }), trigger: 'change' }
                ],
                identityRule: [
                    { required: true, message: this.$translate('lang.E3202103090018', { defaultText: '请选择标识生成规则' }), trigger: 'change' }
                ],
                template: [
                    { required: true, message: this.$translate('lang.E3202103090019', { defaultText: '请选择打印模板' }), trigger: 'change' }
                ],
                printCopies: [
                    { required: true, message: this.$translate('lang.E3202103090020', { defaultText: '请选择打印份数' }), trigger: 'change' }
                ],
                createNum: [
                    { required: true, message: this.$translate('lang.E3202103090021', { defaultText: '请选择生成数量' }), trigger: 'change' },
                    { validator: validateNull, trigger: 'blur' }
                ],
                createDate: [
                    { required: true, message: this.$translate('lang.E3202103090022', { defaultText: '请选择日期' }), trigger: 'change' }
                ],
                startNum: [
                    { required: true, message: this.$translate('lang.E3202103090023', { defaultText: '请生成号段起' }), trigger: 'change' }
                ],
                endNum: [
                    { required: true, message: this.$translate('lang.E3202103090024', { defaultText: '请生成号段止' }), trigger: 'change' }
                ]
            },
            templateOptions: [
                {
                    value: '001',
                    label: this.$translate('lang.E3202103090016', { defaultText: '家电工业互联网标识打印模版' })
                }
            ],
            showProperty: false,
            // 基础属性
            attributeArray: [],
            page: {
                pageSize: 10,
                pageNo: 1
            },
            searchData: {},
            producSelectData: [],
            identitySelectData: []
        };
    },
    methods: {
        changeDate() {
            this.getStartEndNum();
        },
        // 打印
        printButton(ruleForm) {
            const that = this;
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    if (this.formInline.printCopies * this.formInline.createNum > 1000) {
                        this.$message.warning(this.$translate('lang.EXC202103090001', { defaultText: '打印生成数量不能超1000' }));
                        return;
                    };
                    const params = {
                        ...this.formInline
                    };
                    params['seqNumber'] = this.producSelectData[0].seqNumber;
                    if (this.producSelectData.length && this.producSelectData[0].link) {
                        params['link'] = this.producSelectData[0].link;
                    };
                    params['productCode'] = this.producSelectData[0]['productCode'];
                    params['identityAttributes'] = this.producSelectData[0]['productAttributeList'];
                    params['productTemplateCode'] = this.producSelectData[0]['productTemplateCode'];
                    params['productTemplateName'] = this.producSelectData[0]['productTemplateName'];
                    setRegistered(params).then(res => {
                        if (res.code === '0') {
                            this.$message({
                                message: that.$translate('lang.EXC202103090002', { defaultText: '生成成功' }),
                                type: 'success',
                                onClose() {
                                    setSNumber(res.data).then(item => {
                                        if (+item === 0) {
                                            // var a = document.createElement('a');
                                            const str = res.data + '&prefixCode=' + that.currentTenant.tenantCode;
                                            // a.href = 'http://snpsitapi.midea.com/api-printer/preview?_report=ReportIdentity&_ignore=true&batchNum=' + str;
                                            // a.target = '_blank';
                                            // a.click();
                                            window.open(that.configHttp.apiUrl + '/api-printer/preview?_report=ReportIdentity&_ignore=true&batchNum=' + str, '_blank');
                                        } else {
                                            that.$message.warning(that.$translate('lang.EXC202103090003', { defaultText: '打印超时,请到标识查询页面进行打印' }));
                                        }
                                        that.printloading = false;
                                    }).catch(res => {
                                        that.printloading = false;
                                    });
                                    that.getStartEndNum();
                                }
                            });
                            that.printloading = true;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 重置
        restPrint() {
            for (const key of Object.keys(this.formInline)) {
                this.formInline[key] = '';
            }
            this.formInline['identityRule'] = 'R01';
            this.formInline['template'] = this.$translate('lang.E3202103090016', { defaultText: '家电工业互联网标识打印模版' });
            this.isProperty = false;
            this.formInline['createDate'] = this.getTime();
        },
        // 产品
        detaliSearch() {
            const params = {
                ...this.page
            };
            this.getProduct(params);
            this.formInline['startNum'] = '';
            this.formInline['endNum'] = '';
            this.formInline['createNum'] = '';
            this.formInline['productName'] = '';
            if (this.$refs.Product) {
                this.$refs.Product.$refs.SearchLsit.clearsearchData();
            }
        },
        async getProduct(params) {
            params['status'] = 'Y';
            await getProductList(params).then(res => {
                if (res.code === '0') {
                    this.InformationPageTotal = res.data.totalCount;
                    this.InformationTableData = res.data.list;
                }
            });
            this.dialogVisible = true;
        },
        onSearchChange (data) {
            this.searchData = data;
            const params = {
                ...data,
                ...this.page
            };
            this.getProduct(params);
        },
        productInformationSelec(data) {
            this.producSelectData = data;
        },
        productPageChange(pageNo) {
            const params = {
                ...this.page,
                ...this.searchData
            };
            params['pageNo'] = pageNo;
            this.getProduct(params);
        },
        productSizeChange(size) {
            const params = {
                ...this.page,
                ...this.searchData
            };
            params['pageSize'] = size;
            this.getProduct(params);
        },
        productInformation() {
            if (this.producSelectData.length === 0) {
                this.$message.warning(this.$translate('lang.EXC202103090004', { defaultText: '请选择任一产品' }));
                return;
            };
            this.formInline['productName'] = this.producSelectData[0].productName;
            if (this.producSelectData[0].jump === 'N') {
                this.attributeArray = this.producSelectData[0].productAttributeList;
            }
            this.dialogVisible = false;
            this.isProperty = true;
        },
        // 属性
        mouseOver() {
            this.showProperty = true;
        },
        // 标识生成规则
        identifyGeneratedSearch() {
            this.identifyGeneratedVisible = true;
            this.formInline['startNum'] = '';
            this.formInline['endNum'] = '';
            this.formInline['createNum'] = '';
        },
        identifyGeneratedSelec(data) {
            this.identitySelectData = data;
        },
        identifyGenerated() {
            if (this.identitySelectData.length === 0) {
                this.$message.warning(this.$translate('lang.E3202103090018', { defaultText: '请选择标识生成规则' }));
                return;
            }
            this.formInline['identityRule'] = this.identitySelectData[0].identityRule;
            this.identifyGeneratedVisible = false;
        },
        // 获取起止
        getStartEndNum: Throttle(function() {
            if (this.producSelectData.length === 0 && this.formInline.createNum !== 0) {
                this.$message.warning(this.$translate('lang.E3202103090017', { defaultText: '请先选择产品' }));
                return;
            }
            if (this.formInline.createNum > 1000) {
                this.$message.warning(this.$translate('lang.EXC202103090005', { defaultText: '生成数量不能超1000' }));
                return;
            };
            if (this.formInline.createNum === 0) {
                return;
            };
            const params = {};
            params['tenantCode'] = '';
            params['productCode'] = this.producSelectData[0].productCode;
            params['identityRule'] = this.formInline['identityRule'];
            params['createDate'] = this.formInline['createDate'];
            params['createNum'] = this.formInline['createNum'];
            params['seqNumber'] = this.producSelectData[0].seqNumber;
            if (this.producSelectData.length && this.producSelectData[0].link) {
                params['link'] = this.producSelectData[0].link;
            };
            getParagraph(params).then(res => {
                if (res.code === '0') {
                    this.formInline['startNum'] = res.data['startNum'];
                    this.formInline['endNum'] = res.data['endNum'];
                }
            });
        }, 2000),
        // 获得当前时间
        getTime() {
            const date = new Date();
            const seperator1 = '-';
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            const currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        }
    },
    mounted() {
        this.formInline['createDate'] = this.getTime();
    },
    computed: {
        ...mapGetters(['user', 'currentTenant'])
    }
};
</script>
<style lang="less" src='./index.less'>
</style>